import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import styled from 'foundations-theming/utils';
import { useIsMobile } from 'pricing-pages-lib/context/IsMobileContext';
import { PageSection, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { CompanyProofsMap } from '../../constants/company-proof/CompanyProofConfig';
import { SCREENS } from '../../constants/tracking/Screens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconGridItem = styled.div.withConfig({
  displayName: "CompanyProof__IconGridItem",
  componentId: "sc-1cqpoqj-0"
})(["grid-column:span 4;display:flex;justify-content:center;align-items:center;&:nth-child(4){grid-row-start:2;grid-column:3 / span 4;}&:nth-child(5){grid-row-start:2;grid-column:7 / span 4;}"]);
const IconsGrid = styled.div.withConfig({
  displayName: "CompanyProof__IconsGrid",
  componentId: "sc-1cqpoqj-1"
})(["width:100%;display:grid;grid-template-columns:repeat(12,1fr);grid-row-gap:38px;"]);
const CompanyProof = ({
  tab,
  screen
}) => {
  const companyProofs = CompanyProofsMap[tab];

  // Hide on mobile if not commerce
  const isMobile = useIsMobile();
  if (isMobile && screen !== SCREENS.COMMERCE) {
    return null;
  }
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.companyProof.title"
        })
      }), /*#__PURE__*/_jsx(SectionSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.companyProof.subtitle"
        })
      })]
    }), /*#__PURE__*/_jsx(IconsGrid, {
      children: companyProofs.map(company => /*#__PURE__*/_jsx(IconGridItem, {
        children: /*#__PURE__*/_jsx(Image, {
          src: company.icon,
          alt: company.name,
          objectFit: "contain",
          inlineSize: "110px"
        })
      }, company.name))
    })]
  });
};
export default CompanyProof;